import * as Sentry from '@sentry/react';

import { IUser } from '../user';

export class SentryService {
  private static isInitialized = false;

  public static initialize(profile: IUser, isProduction: boolean): void {
    if (typeof window === 'undefined' || !isProduction) return;

    if (!this.isInitialized) {
      Sentry.init({
        dsn: 'https://a2021070541a4e5aade6bb4542a3e745@o4504486824837120.ingest.sentry.io/4504486828572672',
        integrations: [
          new Sentry.Replay(),
          Sentry.browserTracingIntegration(),
          Sentry.browserProfilingIntegration()
        ],
        tracesSampleRate: 1.0,
        replaysSessionSampleRate: 0.1,
        replaysOnErrorSampleRate: 1.0,
        environment: 'production'
      });

      this.isInitialized = true;
    }

    Sentry.setUser({
      id: profile._id,
      email: profile.email,
      username: `${profile.name} ${profile.lastName}`
    });
  }
}
